import React, { useEffect } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { connect } from "react-redux";

import noop from "../../helpers/noop";
import CreateCouponForm from "../Forms/CreateCouponForm";
import VideoPlayer from '../Common/VideoPlayer';
import styles from './modal.module.scss';
import { clearVideoFetched, getVideo } from '../../store/dashboard/VideoLibrary/actions';
import BlueSpinner from '../Common/Spinner';
import VideoWhereUsedInfo from '../../pages/Dashboard/VideoLibrary/components/VideoWhereUsedInfo';

const ShowVideoInfoInModal = ({
  onCancel = noop,
  onConfirm = noop,
  isOpen,
  video,
  videoLibrary,
  getVideo,
  clearVideoFetched
}) => {
  // const saveCouponHandler = (model) => onConfirm(model);
  // const dispatch = 

  const { loadingGetVideo, item: videoWithInfo } = videoLibrary;

  useEffect(() => {
    if (isOpen) {
      getVideo(video.id);
    }

    return () => {
      // clearVideoFetched();
    }
  }, [video, isOpen]);

  return (
    <Modal isOpen={isOpen} centered toggle={() => onCancel()}>
      <ModalHeader toggle={() => onCancel()}>
        Video Info for: {video.id}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            {loadingGetVideo && (
              <div className={styles.loading}>
                <BlueSpinner withMargin={false} withPadding={false} />
              </div>
            )}
            {!loadingGetVideo && videoWithInfo  && (
              <VideoWhereUsedInfo video={videoWithInfo} />
              )}
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = ({ VideoLibrary }) => {
  return {
    videoLibrary: VideoLibrary,
  };
};

export default connect(mapStateToProps, { getVideo, clearVideoFetched })(ShowVideoInfoInModal);